import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { Loading } from './types';

const initialState = {
  loading: {} as any,
  lang: '',
  widen: false,
  hospital_id: 0,
  env: {} as any,
};

const totalSlice = createSlice({
  name: 'total',
  initialState,
  reducers: {
    setEnv: (state, action: PayloadAction<{ data: any }>) => {
      state.env = action.payload.data;
    },
    setHospitalId: (state, { payload: { data } }: PayloadAction<{ data: number }>) => {
      state.hospital_id = data;
    },

    loading: (state, action: PayloadAction<Loading>) => {
      const { status, key } = action.payload;
      const message = get(action.payload, 'message', 'Tiến trình đang thực hiện ...');

      state.loading = {
        [key]: {
          status,
          message,
        },
        ...state.loading,
      };
    },
  },
});

export const totalActions = totalSlice.actions;
export default totalSlice;
